import { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { saveStates, states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import openSystemCohort from './state';
import { mergeCohort } from '../../state/state';
import validateQuery from '../../queries/helper';
import { findCohort } from '../../state/shared';

const fetchSystemCohort = withDraft((draft, action) => {
  const item = findCohort(draft, action, 'requestCode');
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    const props = openSystemCohort(action.code);
    draft.cohorts[action.category].results.push(props);
  }
});

const showSystemCohort = withDraft((draft, action) => {
  const item = findCohort(draft, action, 'requestCode');
  const errors = [];
  const queries = mergeCohort(action.result, item);

  queries.forEach((query) => validateQuery(query, errors, true));

  assignProps(item, {
    ...action.result,
    readStatus: states.SUCCESS,
    readErrors: [],
    validationErrors: errors,
    ...saveStates,
    queries,
    activeQueryUUID: queries.length ? queries[0].uuid : null,
    isDirty: false,
  });
});

const showSystemCohortError = withDraft((draft, action) => {
  const item = findCohort(draft, action, 'requestCode');
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeSystemCohort = withDraft((draft, action) => {
  const item = findCohort(draft, action, 'requestCode');
  if (item?.code) {
    draft.cohorts[action.category].results = removeItemByCode(draft.cohorts[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_SYSTEM_COHORT]: closeSystemCohort,
  [actions.FETCH_SYSTEM_COHORT]: fetchSystemCohort,
  [actions.SHOW_SYSTEM_COHORT]: showSystemCohort,
  [actions.SHOW_SYSTEM_COHORT_ERROR]: showSystemCohortError,
};
